"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var widget_body_html_1 = __importDefault(require("./widget-body.html"));
(function (module) {
    'use strict';
    var PRODUCT_BASE_COMPONENT = 'pr.product-base-component';
    module.directive('prWidgetBody', [
        '$q',
        'rsEnvironment',
        'rsWidgets',
        'prCustomWidgetService',
        '$timeout',
        'prActiveReport',
        'prEventService',
        function ($q, env, rsWidgets, customWidgetService, $timeout, activeReport, eventService) {
            return {
                restrict: 'E',
                templateUrl: widget_body_html_1.default,
                require: {
                    bodyCtrl: '?^^prBody'
                },
                // we will rely on a widget existing from widget.js
                scope: false,
                link: function ($scope, $element, attrs, bodyController) {
                    var wScope;
                    $element.on('$destroy', function destroy() {
                        $element.off('$destroy');
                        eventService.stream($scope.widget._id).off('widgetSectionUpdated', loadBody);
                        var pageId = activeReport.getPageIdOfWidget($scope.widget);
                        rsWidgets.unload($scope.widget._id, pageId);
                        $scope.$destroy();
                        $scope = null;
                        $element = null;
                        // kill the widget scope with fire!!!
                        if (wScope) {
                            wScope.$destroy();
                            wScope = null;
                        }
                    });
                    function loadBody() {
                        if (!$scope) {
                            // there is a race condition where loadBody will run after $destroy has been called
                            // That's because the 'widgetSectionUpdated' will trigger both $destroy and loadBody,
                            // even though $destroy removes the loadBody callback.
                            return;
                        }
                        var widget = $scope.widget;
                        var wId = widget._id;
                        var pageId = activeReport.getPageIdOfWidget(widget);
                        var containerId = env.get('containerId');
                        var wType = widget._type;
                        var el = getWidgetContainer();
                        if (isNonResizableWidgetType(wType)) {
                            el.closest('pr-widget').attr('resize', 'none');
                        }
                        el.empty();
                        // Ensure each dependency
                        var customWidgets = customWidgetService.getCustomWidgets();
                        var dependencies = customWidgets && _.get(customWidgets[wType], 'dependencies');
                        dependencies = [PRODUCT_BASE_COMPONENT].concat(dependencies || []);
                        return $q.all(dependencies.map(rsWidgets.ensureDependency)).then(function () {
                            return rsWidgets.loadBody(wType, wId, el, null, pageId);
                        }).catch(function (error) {
                            console.error(error);
                            if (error.status === 401) {
                                $scope.setWidgetError('WIDGET_STATES.UNAUTHORIZED');
                            }
                            else if (widgetNotFound(error.message)) {
                                $scope.setWidgetError('WIDGET_STATES.NOT_FOUND');
                            }
                            else {
                                $scope.setWidgetError('WIDGET_STATES.ERROR');
                            }
                        }).then(function () {
                            wScope = rsWidgets.getWidgetScope(wId, pageId, containerId);
                            // Sometimes the sidebar is opened before the widget/dependency code is
                            // fully loaded, which can cause ordering issues. To fix, re-open the
                            // sidebar here now that all widget/dependency code is loaded.
                            var activeWidgetId = _.get(bodyController, 'bodyCtrl.activeWidgetId');
                            if (activeWidgetId === wId) {
                                bodyController.bodyCtrl.activeWidgetId = null;
                                $timeout(function () {
                                    bodyController.bodyCtrl.activeWidgetId = activeWidgetId;
                                });
                            }
                        });
                    }
                    loadBody();
                    // listen to widgetSectionUpdated event to reload widget body
                    eventService.stream($scope.widget._id).on('widgetSectionUpdated', loadBody);
                    function getWidgetContainer() {
                        return $element.children();
                    }
                    function widgetNotFound(errorMsg) {
                        return errorMsg &&
                            errorMsg.indexOf('Metadata for ') >= 0 &&
                            errorMsg.indexOf('not found');
                    }
                    function isNonResizableWidgetType(type) {
                        return _.includes(customWidgetService.getNonResizableWidgets(), type);
                    }
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
